/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stat_Students_ValueInputs */

const en_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000s`)
};

const es_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const de_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const zh_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const ar_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const fr_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const vi_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const sw_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const th_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const bs_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const ja_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const ko_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const pt_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const it_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const sv_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const nl_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const da_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const nb_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const fi_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const pl_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const ru_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const tr_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const hi_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const id_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const ms_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const cs_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const el_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const he_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const af_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

const hu_home_stat_students_value = /** @type {(inputs: Home_Stat_Students_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000+`)
};

/**
* | output |
* | --- |
* | "1000s" |
*
* @param {Home_Stat_Students_ValueInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_stat_students_value = /** @type {((inputs?: Home_Stat_Students_ValueInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stat_Students_ValueInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_stat_students_value(inputs)
	if (locale === "de") return de_home_stat_students_value(inputs)
	if (locale === "zh") return zh_home_stat_students_value(inputs)
	if (locale === "ar") return ar_home_stat_students_value(inputs)
	if (locale === "fr") return fr_home_stat_students_value(inputs)
	if (locale === "vi") return vi_home_stat_students_value(inputs)
	if (locale === "sw") return sw_home_stat_students_value(inputs)
	if (locale === "th") return th_home_stat_students_value(inputs)
	if (locale === "bs") return bs_home_stat_students_value(inputs)
	if (locale === "ja") return ja_home_stat_students_value(inputs)
	if (locale === "ko") return ko_home_stat_students_value(inputs)
	if (locale === "pt") return pt_home_stat_students_value(inputs)
	if (locale === "it") return it_home_stat_students_value(inputs)
	if (locale === "sv") return sv_home_stat_students_value(inputs)
	if (locale === "nl") return nl_home_stat_students_value(inputs)
	if (locale === "da") return da_home_stat_students_value(inputs)
	if (locale === "nb") return nb_home_stat_students_value(inputs)
	if (locale === "fi") return fi_home_stat_students_value(inputs)
	if (locale === "pl") return pl_home_stat_students_value(inputs)
	if (locale === "ru") return ru_home_stat_students_value(inputs)
	if (locale === "tr") return tr_home_stat_students_value(inputs)
	if (locale === "hi") return hi_home_stat_students_value(inputs)
	if (locale === "id") return id_home_stat_students_value(inputs)
	if (locale === "ms") return ms_home_stat_students_value(inputs)
	if (locale === "cs") return cs_home_stat_students_value(inputs)
	if (locale === "el") return el_home_stat_students_value(inputs)
	if (locale === "he") return he_home_stat_students_value(inputs)
	if (locale === "af") return af_home_stat_students_value(inputs)
	if (locale === "hu") return hu_home_stat_students_value(inputs)
	return en_home_stat_students_value(inputs)
});